import { QueryObserverResult } from 'react-query';
import {
  AssociateSetupResponse,
  OnboardingSteps,
  useGetAssociateSetupState,
} from '@vs-online-only-app/state';
import { createContext, FC, PropsWithChildren, useMemo } from 'react';

type AssociateSetupState = {
  hasCompletedProfileSetup: boolean;
  hasCompletedIntroModules: boolean;
  associateSetupState?: AssociateSetupResponse;
  refetchSetupState: () => Promise<
    QueryObserverResult<AssociateSetupResponse, unknown>
  >;
};

const AssociateSetupContext = createContext<AssociateSetupState>(
  {} as AssociateSetupState,
);

const AssociateSetupProvider: FC<PropsWithChildren> = (props) => {
  const { data: associateSetupState, refetch } = useGetAssociateSetupState();

  const hasCompletedProfileSetup = useMemo(
    () =>
      associateSetupState?.onboarding.current !== OnboardingSteps.profileSetup,
    [associateSetupState],
  );

  const hasCompletedIntroModules = useMemo(
    () =>
      associateSetupState?.onboarding.current !== OnboardingSteps.introduction,
    [associateSetupState],
  );

  const value: AssociateSetupState = useMemo(
    () => ({
      hasCompletedProfileSetup,
      associateSetupState,
      refetchSetupState: refetch,
      hasCompletedIntroModules,
    }),
    [
      associateSetupState,
      hasCompletedIntroModules,
      hasCompletedProfileSetup,
      refetch,
    ],
  );

  return (
    <AssociateSetupContext.Provider value={value}>
      {props.children}
    </AssociateSetupContext.Provider>
  );
};

export { AssociateSetupProvider, AssociateSetupContext };
